import { SwapOrReturnTag } from './SwapOrReturnTag'

export default SwapOrReturnTag
